/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_System_Cache_BypassInputs */

const bn_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বাইপাস`)
};

const de_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BYPASS`)
};

const el_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΠΑΡΑΚΑΜΠΤΗΡΙΟΣ ΟΔΟΣ`)
};

const en_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BYPASS`)
};

const es_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DERIVACIÓN`)
};

const fr_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CONTOURNEMENT`)
};

const hi_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाईपास`)
};

const hu_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KITÉRŐ`)
};

const id_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEPAS`)
};

const it_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ESCLUSIONE`)
};

const ja_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バイパス`)
};

const ko_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`우회로`)
};

const nl_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OMLEIDING`)
};

const pl_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OBJAZD`)
};

const pt_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IGNORAR`)
};

const ru_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ОБХОД`)
};

const sv_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GÅ FÖRBI`)
};

const tr_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BYPASS`)
};

const uk_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ОБХІД`)
};

const vi_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ĐƯỜNG VÒNG`)
};

const zh_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旁路`)
};

const zh_hant_cipher_system_cache_bypass = /** @type {(inputs: Cipher_System_Cache_BypassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旁路`)
};

/**
* | output |
* | --- |
* | "BYPASS" |
*
* @param {Cipher_System_Cache_BypassInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_system_cache_bypass = /** @type {((inputs?: Cipher_System_Cache_BypassInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_System_Cache_BypassInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_system_cache_bypass(inputs)
	if (locale === "de") return de_cipher_system_cache_bypass(inputs)
	if (locale === "el") return el_cipher_system_cache_bypass(inputs)
	if (locale === "en") return en_cipher_system_cache_bypass(inputs)
	if (locale === "es") return es_cipher_system_cache_bypass(inputs)
	if (locale === "fr") return fr_cipher_system_cache_bypass(inputs)
	if (locale === "hi") return hi_cipher_system_cache_bypass(inputs)
	if (locale === "hu") return hu_cipher_system_cache_bypass(inputs)
	if (locale === "id") return id_cipher_system_cache_bypass(inputs)
	if (locale === "it") return it_cipher_system_cache_bypass(inputs)
	if (locale === "ja") return ja_cipher_system_cache_bypass(inputs)
	if (locale === "ko") return ko_cipher_system_cache_bypass(inputs)
	if (locale === "nl") return nl_cipher_system_cache_bypass(inputs)
	if (locale === "pl") return pl_cipher_system_cache_bypass(inputs)
	if (locale === "pt") return pt_cipher_system_cache_bypass(inputs)
	if (locale === "ru") return ru_cipher_system_cache_bypass(inputs)
	if (locale === "sv") return sv_cipher_system_cache_bypass(inputs)
	if (locale === "tr") return tr_cipher_system_cache_bypass(inputs)
	if (locale === "uk") return uk_cipher_system_cache_bypass(inputs)
	if (locale === "vi") return vi_cipher_system_cache_bypass(inputs)
	if (locale === "zh") return zh_cipher_system_cache_bypass(inputs)
	return zh_hant_cipher_system_cache_bypass(inputs)
});